<template>
  <v-app>
    <v-app-bar app color="indigo" dark clipped-left>
      <v-app-bar-nav-icon v-show="!drawer" v-on:click.stop="drawer = !drawer" />
      <v-toolbar-title>CHSS Course Catalog</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            :class="$vuetify.breakpoint.mdAndDown ? 'indigo' : 'green'"
            :depressed="$vuetify.breakpoint.mdAndDown ? true : false"
            :icon="$vuetify.breakpoint.mdAndDown ? true : false"
            v-on="on"
          >

            <v-badge
              :value="$vuetify.breakpoint.mdAndDown==true && filteredGrade != null"
              color="green lighten-1"
              bordered
              left
              light
              overlap
              :content=filteredGrade
            >
            <v-icon
              v-show="$vuetify.breakpoint.mdAndDown==true"
              :color="filteredGrade == null ? 'white' : 'green lighten-1'"
            >
              mdi-filter
            </v-icon>
            </v-badge>
            <span class="white--text">{{ filterButtonText }}</span>
            <v-chip
              v-show="filteredGrade != null && $vuetify.breakpoint.mdAndDown != true"
              class="ml-3 font-weight-bold"
              color="green darken-2"
            >
              <span class="white--text">{{ filteredGrade }}</span>
            </v-chip>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(grade, index) in gradeFilters"
            :key="index"
            v-on:click="filterByGrade(grade.value)"
          >
            <v-list-item-title>{{ grade.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      width="310px"
      floating
      color="blue lighten-5"
    >

  <!-- DISABLE EXPANSION PANELS (NO COURSE SELECTION)
      <v-expansion-panels flat>
        <v-expansion-panel>
          <v-expansion-panel-header class="subtitle-1" color="blue lighten-5">
            Browse Courses
          </v-expansion-panel-header>
          <v-expansion-panel-content color="blue lighten-5">
          -->

            <v-list color="blue lighten-5" dense>
              <v-list-item-group v-model='selectedDepartment'>
                <v-list-item
                  v-for="department in departments"
                  v-bind:key="department.name"
                  v-on:click="selectDepartment(department.name)"
                  link
                >
                <v-list-item-action>
                  <v-icon color="blue darken-3">{{ department.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ department.name }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
              </v-list-item-group>

               <v-list-item>
              </v-list-item>

            </v-list>

          <!-- DISABLE EXPANSION PANELS (NO COURSE SELECTION)
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="subtitle-1" color="blue lighten-5">
            Course Selection
          </v-expansion-panel-header>
          <v-expansion-panel-content color="blue lighten-5">
            <v-list color="blue lighten-5" dense>
              <v-list-item-group v-model='grade'>
                <v-list-item
                v-on:click="selectGrade(9)"
                link>
                <v-list-item-action>
                  <v-icon color="blue darken-3">mdi-emoticon-excited-outline</v-icon>
                </v-list-item-action>
                  <v-list-item-content>
                  <v-list-item-title>Entering Grade 9</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-on:click="selectGrade(10)"
                link>
                <v-list-item-action>
                  <v-icon color="blue darken-3">mdi-emoticon-happy-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Entering Grade 10</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-on:click="selectGrade(11)"
                link>
                <v-list-item-action>
                  <v-icon color="blue darken-3">mdi-emoticon-wink-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Entering Grade 11</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-on:click="selectGrade(12)"
                link>
                <v-list-item-action>
                  <v-icon color="blue darken-3">mdi-emoticon-cool-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Entering Grade 12</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      -->
    </v-navigation-drawer>
    <v-main>
      <v-container fluid>
        <router-view
          :filteredGrade="this.filteredGrade">
        </router-view>
      </v-container>
    </v-main>
    <v-footer
      color="indigo"
      app
    >
      <span class="white--text">Web app by J. Wick</span>
    </v-footer>
  </v-app>
</template>

<script>
import {courses} from './courses.js';
import router from '@/plugins/router.js';

export default {
  name: 'App',

  methods: {
    selectDepartment: function(dept) {
      this.selectedDepartment = dept;
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false;
      }
      router.push({name: 'Browse', params: {department: dept}})
        .catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
    },
/*    selectGrade: function(grade) {
      this.selectedGrade = grade;
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false;
      }
      router.push({name: 'Selection', params: {grade: grade}});
    },
*/
    filterByGrade: function(grade) {
      this.filteredGrade = grade;
    },
  },

  computed: {
    filterButtonText: function() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return "";
      } else {
        return "Filter By Grade";
      }
    }
  },

  data: () => ({
    courses: courses,
    grade: null,
    drawer: null,
    selectedDepartment: null,
    selectedGrade: null,
    filteredGrade: null,
    showPreviewPane: false,

    gradeFilters: [
      {title: 'Show All', value: null},
      {title: 'Grade 9', value: 9},
      {title: 'Grade 10', value: 10},
      {title: 'Grade 11', value: 11},
      {title: 'Grade 12', value: 12}
    ],

    departments: [
    {
      name: 'English',
      icon: 'mdi-feather'
    },
    {
      name: 'Math',
      icon: 'mdi-exponent'
    },
    {
      name: 'Science',
      icon: 'mdi-flask-empty-outline'
    },
    {
      name: 'Social Studies',
      icon: 'mdi-globe-model'
    },
    {
      name: 'Physical & Health Education',
      icon: 'mdi-run'
    },
    {
      name: 'Second Languages',
      icon: 'mdi-comment-text-outline'
    },
    {
      name: 'Business',
      icon: 'mdi-finance'
    },
    {
      name: 'Drama',
      icon: 'mdi-drama-masks'
    },
    {
      name: 'Home Economics',
      icon: 'mdi-food-fork-drink'
    },
    {
      name: 'Information Technology',
      icon: 'mdi-tablet-cellphone'
    },
    {
      name: 'Music',
      icon: 'mdi-music'
    },
    {
      name: 'Technology',
      icon: 'mdi-hammer-wrench'
    },
    {
      name: 'Visual Arts',
      icon: 'mdi-brush'
    },
    {
      name: 'Français Langue Seconde-Immersion',
      icon: 'mdi-web'
    },
    {
      name: 'Career Education and Preparation',
      icon: 'mdi-excavator'
    },
  ],
  })
};
</script>
